import { IPublication } from '@opengov/stories-shared/types';

import { shareOnlinePublication } from '../routes/hasura';

export type GenerateOnlinePublicationUrlParams = {
  publication: IPublication;
  userId: number;
  update: boolean;
  enableGoogleTranslateForPublications: boolean;
  isPreview: boolean;
  entitySubdomain: string;
  notifyAdmins?: boolean;
};

// Throws on failure so callers can trigger their own toast via mutation
// `onError` or a `.catch`.
export async function generateOnlinePublicationUrl(
  params: GenerateOnlinePublicationUrlParams
): Promise<string> {
  const {
    publication,
    userId,
    update: _update,
    enableGoogleTranslateForPublications,
    isPreview,
    entitySubdomain,
    notifyAdmins
  } = params;
  const publicationId = publication.id;
  // `String.prototype.split('/').pop()` returns `string | undefined`; default
  // to '' so the param matches `ShareOnlinePublicationParams.publishedId: string`.
  const publishedId =
    publication?.publicUrl && !isPreview ? publication.publicUrl.split('/').pop() ?? '' : '';

  const url = await shareOnlinePublication({
    publicationId,
    entitySubdomain,
    publishedId,
    userId,
    enableGoogleTranslateForPublications,
    isPreview,
    notifyAdmins
  });

  if (!url) {
    throw new Error('generateOnlinePublicationUrl: empty response from share endpoint');
  }

  // Timestamp update + publication refresh moved to the hook layer.
  // `useGenerateOnlinePublicationUrl` chains `useUpdatePublicationUpdatedAt` +
  // invalidates publication query. Direct callers (non-hook components) must
  // handle refresh themselves.

  return url;
}
